import type { TranslateFn } from '@/types/domain';

interface TranslationListItem {
  li: string;
}

interface TranslationNode {
  h1?: string;
  h2?: string;
  h3?: string;
  h4?: string;
  p?: string;
  ul?: TranslationListItem[];
  ol?: TranslationListItem[];
  [key: string]: string | TranslationListItem[] | undefined;
}

type TranslationContentItem =
  Record<string, string> | Record<string, TranslationListItem[]>;

export default function convertDataToTranslation(
  data: TranslationNode[],
  t: TranslateFn,
): TranslationContentItem[] {
  const content: TranslationContentItem[] = [];

  data.map((node) => {
    const key = Object.keys(node)[0];
    switch (key) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'p': {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- value is present by contract here but the GraphQL type is nullable; re-type from codegen to remove
        content.push({ [key]: t(node[key]!) });
        break;
      }
      case 'ul': {
        const listContent: TranslationListItem[] = [];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- value is present by contract here but the GraphQL type is nullable; re-type from codegen to remove
        node.ul!.map((item) => {
          listContent.push({ li: t(item.li) });
          return '';
        });
        content.push({ [key]: listContent });
        break;
      }
      case 'ol': {
        const listContent: TranslationListItem[] = [];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- value is present by contract here but the GraphQL type is nullable; re-type from codegen to remove
        node.ol!.map((item) => {
          listContent.push({ li: t(item.li) });
          return '';
        });
        content.push({ [key]: listContent });
        break;
      }
    }

    return '';
  });

  return content;
}
